import React from "react"
import { Dialog } from "functional-foundations"
import { makeStyles } from "@material-ui/core/styles"
import { DialogType } from "functional-foundations/types"
import { Button, Icon, Typography } from "foundations-library/components"

const useStyles = makeStyles((theme) => {
    const { colors } = theme["foundations-library"]

    return {
        dialog: {
        },
        content: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            paddingTop: 20
        },
        statusIcon: {
            width: 60,
            height: 60,
            borderRadius: "50%",
            backgroundColor: colors.primary[500],
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 20
        },
        header: {
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 20,
            padding: "20px 0 10px"
        },
        title: {
            color: colors.neutral[900],
            letterSpacing: "-0.2px"
        },
        message: {
            color: colors.neutral[900],
            maxWidth: 400
        },
        actions: {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            paddingTop: 30,
            paddingBottom: 10
        },
        button: {
            minWidth: 290,
            paddingLeft: 16,
            paddingRight: 8
        }
    }
})

type PropsType = {
    onContinue(): unknown
} & DialogType

/**
 *
 */
const CampaignSubmittedDialog = ({
    onContinue,
    ...props
}: PropsType): JSX.Element => {
    const classes = useStyles()

    return (
        <Dialog
            width={640}
            className={classes.dialog}
            closeOnClickOutside={false}
            data-testid="campaign-submitted-dialog"
            {...props}
        >
            <div className={classes.content}>
                <div className={classes.statusIcon}>
                    <Icon name="check-alt" size={60} />
                </div>
                <div className={classes.header}>
                    <Typography variant="h6" className={classes.title}>
                        Your campaign has been submitted successfully.
                    </Typography>
                    <Typography variant="body1" className={classes.message}>
                        Next, assign phone numbers to enable SMS messaging.
                    </Typography>
                </div>
                <div className={classes.actions}>
                    <Button
                        color="primary"
                        icon="go"
                        className={classes.button}
                        onClick={onContinue}
                    >
                        Continue to Number Assignment
                    </Button>
                </div>
            </div>
        </Dialog>
    )
}

export default CampaignSubmittedDialog
